<div class="handshakes-list">
  <div class="handshakes-list__header" ubi-dialog-title>
    {{data.choosen.name}}
  </div>
  <div class="handshakes-list__content" ubi-dialog-content>
    <div class="handshakes-list__label">
      Please select added CRP to update.
    </div>
    <span class="handshakes-list__content-no-crp" *ngIf="!data.existing || data.existing.length ==0"></span>
    <div *ngIf="data.existing && data.existing.length > 0" class="handshakes-list__container">
      <mat-list class="custom-mat-list">
        <mat-list-item *ngFor="let item of data.existing" class="custom-mat-list-item" (click)="select(item)">
          <div mat-line class="handshakes-list__inner">
            <div class="handshakes-list__item">
              <div class="handshakes-list__title">{{ item.name }}</div>
              <div class="handshakes-list__id">{{item.idNumber}}</div>
              <div class="handshakes-list__text">{{getRoleText(item)}}</div>
            </div>
            <div class="handshakes-list__action">
              <button mat-icon-button class="btn custom-mat-icon-button handshakes-list__list-icon">
                <img class="themified-white-icon handshakes-list__icon-select" src="/assets/icons/chevron-right-icon.png">
              </button>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
    <button mat-stroked-button ubi-round-button class="btn" (click)="closeDialog()">Cancel</button>
  </div>
</div>
